
import Vue from 'vue';
import PrimeVue from 'primevue/config';

import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

import MyDialog from './components/register/MyDialog.vue';
import AtecoAutocomplete from './components/register/AtecoAutocomplete.vue';
import UserAgreement from './components/register/UserAgreement.vue';

import CookieBar from './components/layout/CookieBar.vue';

Vue.use(PrimeVue);

Vue.component('my-dialog', MyDialog);
Vue.component('ateco-autocomplete', AtecoAutocomplete);
Vue.component('user-agreement', UserAgreement);
Vue.component('cookie-bar', CookieBar);

new Vue({
    el: '#app',
    created() {
        const agreementEl = document.querySelector('#required-agreements');
        if (agreementEl) {
            this.form.agreements = {};

            JSON.parse(agreementEl.value).forEach(item => {
                this.form.agreements[item] = false;
            });

        }

        const oldEl = document.querySelector('#old-data');
        if (oldEl) {
            const old = JSON.parse(oldEl.value);
            this.form.last_name                 = old.last_name ? old.last_name : null;
            this.form.office_country            = old.office_country ? old.office_country : null;
            this.form.office_state              = old.office_state ? old.office_state : null;
            this.form.office_city               = old.office_city ? old.office_city : null;
            this.form.office_postal_code        = old.office_postal_code ? old.office_postal_code : null;
            this.form.office_address            = old.office_address ? old.office_address : null;
            this.form.email                     = old.email ? old.email : null;
            this.form.pec                       = old.pec ? old.pec : null;
            this.form.vat_number                = old.vat_number ? old.vat_number : null;
            this.form.fiscal_code               = old.fiscal_code ? old.fiscal_code : null;
            this.form.bank_name                 = old.bank_name ? old.bank_name : null;
            this.form.average_revenue           = old.average_revenue ? old.average_revenue : null;
            this.form.phone                     = old.phone ? old.phone : null;
            this.form.iban                      = old.iban ? old.iban : null;
            this.form.bic                       = old.bic ? old.bic : null;
            this.form.ateco_code                = old.ateco_code ? old.ateco_code : null;
            this.form.representative_last_name  = old.representative_last_name ? old.representative_last_name : null;
            this.form.representative_first_name = old.representative_first_name ? old.representative_first_name : null;
            this.form.agreements                = old.agreements ? old.agreements : {};
            this.form.certifications            = old.certifications ? old.certifications : {};
            this.form.accepted_model_231        = old.accepted_model_231 ? old.accepted_model_231 : null;
        }
    },
    data() {
        return {
            form: {
                last_name: null,
                office_country: null,
                office_state: null,
                office_city: null,
                office_postal_code: null,
                office_address: null,
                email: null,
                pec: null,
                vat_number: null,
                fiscal_code: null,
                bank_name: null,
                average_revenue: null,
                phone: null,
                iban: null,
                bic: null,
                ateco_code: null,
                representative_last_name: null,
                representative_first_name: null,
                accepted_model_231: false,
                password: null,
                password_confirmation: null,
                agreements: {},
                certifications: {},

                errors: {
                    agreements: {},
                },
                hasErrors: false,
            },

        };
    },
    methods: {
        uploadFile(e) {
            if (e.target.files && e.target.files.length) {
                const file = e.target.files[0];
                const filename = file.name;
                const label = e.target.nextElementSibling;
                if (label) {
                    const fileNameEl = label.querySelector('.file-name');
                    if (fileNameEl) {
                        fileNameEl.innerText = filename;
                        this.form[e.target.id] = true;
                    }
                }
            }
        },
        refreshCaptcha() {
            const box = document.querySelector('#captcha-box');
            if (box) {
                const img = box.querySelector('img');
                if (img) {
                    img.setAttribute(
                        'src',
                        '/captcha/image?1145846629?_=' +
                            Math.random()
                    );
                    var captcha = document.getElementById('captcha');
                    if (captcha) {
                        captcha.focus();
                    }
                }
            }
        },
        onAnsweredAgreement(e) {
            this.form.agreements[e.id] = e.answered;
        },
        validate() {
            this.form.errors = {};
            this.form.errors.agreements = {};
            this.form.hasErrors = false;

            if (! this.form.last_name) {
                this.form.errors.last_name = true;
                this.form.hasErrors = true;
            }
            if (! this.form.office_country) {
                this.form.errors.office_country = true;
                this.form.hasErrors = true;
            }
            if (! this.form.office_state) {
                this.form.errors.office_state = true;
                this.form.hasErrors = true;
            }
            if (! this.form.office_city) {
                this.form.errors.office_city = true;
                this.form.hasErrors = true;
            }
            if (! this.form.office_postal_code) {
                this.form.errors.office_postal_code = true;
                this.form.hasErrors = true;
            }
            if (! this.form.office_address) {
                this.form.errors.office_address = true;
                this.form.hasErrors = true;
            }
            if (! this.form.email) {
                this.form.errors.email = true;
                this.form.hasErrors = true;
            }
            if (! this.form.pec) {
                this.form.errors.pec = true;
                this.form.hasErrors = true;
            }
            if (! this.form.vat_number) {
                this.form.errors.vat_number = true;
                this.form.hasErrors = true;
            }
            if (! this.form.fiscal_code) {
                this.form.errors.fiscal_code = true;
                this.form.hasErrors = true;
            }
            // if (! this.form.bank_name) {
            //     this.form.errors.bank_name = true;
            //     this.form.hasErrors = true;
            // }
            // if (! this.form.average_revenue) {
            //     this.form.errors.average_revenue = true;
            //     this.form.hasErrors = true;
            // }
            // if (! this.form.phone) {
            //     this.form.errors.phone = true;
            //     this.form.hasErrors = true;
            // }
            // if (! this.form.iban) {
            //     this.form.errors.iban = true;
            //     this.form.hasErrors = true;
            // }
            // if (! this.form.bic) {
            //     this.form.errors.bic = true;
            //     this.form.hasErrors = true;
            // }
            // if (! this.form.ateco_code) {
            //     this.form.errors.ateco_code = true;
            //     this.form.hasErrors = true;
            // }
            if (! this.form.representative_last_name) {
                this.form.errors.representative_last_name = true;
                this.form.hasErrors = true;
            }
            if (! this.form.representative_first_name) {
                this.form.errors.representative_first_name = true;
                this.form.hasErrors = true;
            }
            // if (! this.form.representative_document_path) {
            //     this.form.errors.representative_document_path = true;
            //     this.form.hasErrors = true;
            // }
            if (! this.form.chamber_of_commerce_path) {
                this.form.errors.chamber_of_commerce_path = true;
                this.form.hasErrors = true;
            }
            if (! this.form.accepted_model_231) {
                this.form.errors.accepted_model_231 = true;
                this.form.hasErrors = true;
            }

            if (! this.form.password) {
                this.form.errors.password = true;
                this.form.hasErrors = true;
            }
            if (this.form.password !== this.form.password_confirmation) {
                this.form.errors.password_confirmation = true;
                this.form.hasErrors = true;
            }

            for (const id in this.form.agreements) {
                if (! this.form.agreements[id]) {
                    this.form.errors.agreements[id] = true;
                    this.form.hasErrors = true;
                }
            }

            return this.form.hasErrors;
        },
        submitRegister(e) {
            if (this.validate()) {
                document.querySelector('.register-right').scrollTo(0, 0);
            } else {
                document.querySelector('#register-form').submit();
            }
        },
    },
});

